import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isDisabled", "values", "contentIds", "selectableTeamIds", "defaultOwnerTeamIds", "contentType", "onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchTeams } from 'actions/team';
import Button from 'components/Button';
import FormField, { useFormFieldContext } from 'components/FormField';
import Spinner from 'components/Spinner';
import Pill, { TeamPill } from 'components/Pill';
import InlineList from 'components/InlineList';
import Text from 'components/Text';
import Stack from 'components/Stack';
import Hint from 'components/Hint';
import Flex, { Box } from 'components/Flex';
import HintTooltip from 'components/HintTooltip';
import OwningTeamPickerModal, { noOwningTeamItem } from 'screens/OwningTeamPickerModal';
import useUniqueId from 'hooks/useUniqueId';
import { getUniqueNonNullOwningTeams, useGetDefaultOwningTeamNames } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var OwningTeamField = function OwningTeamField(_ref) {
  var _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$values = _ref.values,
    values = _ref$values === void 0 ? [] : _ref$values,
    _ref$contentIds = _ref.contentIds,
    contentIds = _ref$contentIds === void 0 ? [] : _ref$contentIds,
    selectableTeamIds = _ref.selectableTeamIds,
    defaultOwnerTeamIds = _ref.defaultOwnerTeamIds,
    contentType = _ref.contentType,
    onChange = _ref.onChange,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFormFieldContext = useFormFieldContext(),
    labelId = _useFormFieldContext.labelId;
  var defaultOwningTeamNames = useGetDefaultOwningTeamNames(defaultOwnerTeamIds);
  var count = contentIds.length;
  var isMultiSelect = count > 1;
  var commonTitleId = useUniqueId();
  var indeterminateTitleId = useUniqueId();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showTeamSelectorModal = _useState2[0],
    setShowTeamSelectorModal = _useState2[1];
  var uniqueOwnerTeamIds = _toConsumableArray(new Set(values));
  var isSameOwner = uniqueOwnerTeamIds.length === 1;
  var _useFetchTeams = useFetchTeams({
      teamIds: getUniqueNonNullOwningTeams(values)
    }),
    areOwningTeamsLoading = _useFetchTeams.isLoading,
    _useFetchTeams$items = _useFetchTeams.items,
    owningTeams = _useFetchTeams$items === void 0 ? [] : _useFetchTeams$items;
  var commonOwningTeam = isSameOwner ? owningTeams[0] : null;
  var indeterminateTeams = !isSameOwner ? owningTeams : [];
  var hasOwningTeams = isMultiSelect ? !!commonOwningTeam || indeterminateTeams.length > 0 : !!commonOwningTeam;
  function handleChange(selection) {
    var newOwnerTeamId = selection.selectedItems.id === '' ? null : selection.selectedItems.id;
    var ownerTeamIds = contentIds.map(function () {
      return newOwnerTeamId;
    });
    onChange(ownerTeamIds);
  }
  var selectNewTeam = function selectNewTeam(teamSelection) {
    handleChange(teamSelection);
    setShowTeamSelectorModal(false);
  };
  var handleDelete = function handleDelete() {
    var ownerTeamIds = contentIds.map(function () {
      return null;
    });
    onChange(ownerTeamIds);
    setShowTeamSelectorModal(false);
  };
  var showOwningTeamDeletionInfo =
  // Had initial owning team
  defaultOwningTeamNames.length >= 1 &&
  // Owning team is being removed
  uniqueOwnerTeamIds.length === 1 && (uniqueOwnerTeamIds[0] === null || uniqueOwnerTeamIds[0] === '');
  return /*#__PURE__*/_jsxs(FormField, _objectSpread(_objectSpread({
    as: "fieldset",
    label: isMultiSelect ? t('form_owning_team_plural') : t('form_owning_team'),
    horizontal: true,
    horizontalLabelOffset: 1
  }, otherProps), {}, {
    children: [/*#__PURE__*/_jsxs(Stack, {
      spacing: "xs",
      children: [/*#__PURE__*/_jsxs(Flex, {
        gap: "xxs",
        alignItems: "center",
        children: [areOwningTeamsLoading ? /*#__PURE__*/_jsx(Spinner, {}) : /*#__PURE__*/_jsxs(Box, {
          shrink: true,
          children: [!hasOwningTeams && /*#__PURE__*/_jsx(Pill, {
            dimmed: true,
            children: t('amount_none')
          }), commonOwningTeam && /*#__PURE__*/_jsxs(Stack, {
            spacing: "xs",
            role: "group",
            "aria-labelledby": commonTitleId,
            children: [isMultiSelect && /*#__PURE__*/_jsxs(Flex, {
              children: [/*#__PURE__*/_jsx(Text, {
                id: commonTitleId,
                children: t('property_common')
              }), /*#__PURE__*/_jsx(HintTooltip, {
                content: t("hint_teams_".concat(contentType, "_common")),
                spacingLeft: "xs",
                vAlign: false
              })]
            }), isDisabled ? /*#__PURE__*/_jsx(TeamPill, {
              team: commonOwningTeam
            }, commonOwningTeam.id) : /*#__PURE__*/_jsx(TeamPill, {
              team: commonOwningTeam,
              deleteLabel: t('actions_remove_owning_team'),
              onDelete: handleDelete
            }, commonOwningTeam.id)]
          }), indeterminateTeams.length > 0 && /*#__PURE__*/_jsxs(Stack, {
            spacing: "xs",
            role: "group",
            "aria-labelledby": indeterminateTitleId,
            children: [/*#__PURE__*/_jsxs(Flex, {
              children: [/*#__PURE__*/_jsx(Text, {
                id: indeterminateTitleId,
                children: t('property_individual')
              }), /*#__PURE__*/_jsx(HintTooltip, {
                content: t("hint_teams_".concat(contentType, "_individual"), {
                  count: indeterminateTeams.length
                }),
                spacingLeft: "xs",
                vAlign: false
              })]
            }), /*#__PURE__*/_jsx(InlineList, {
              spacing: "xxs",
              "aria-labelledby": labelId,
              children: indeterminateTeams.map(function (team) {
                return /*#__PURE__*/_jsx(TeamPill, {
                  team: team
                }, team.id);
              })
            })]
          })]
        }), /*#__PURE__*/_jsx(Box, {
          children: /*#__PURE__*/_jsx(Button, {
            size: "small",
            variant: "transparent",
            onClick: function onClick() {
              return setShowTeamSelectorModal(true);
            },
            "aria-label": t('actions_change_owning_team'),
            isDisabled: isDisabled,
            children: t('actions_change')
          })
        })]
      }), showOwningTeamDeletionInfo && /*#__PURE__*/_jsx(Hint, {
        children: t("hint_remove_owning_team_".concat(contentType), {
          count: count,
          teamNames: defaultOwningTeamNames.join(', ')
        })
      })]
    }), showTeamSelectorModal && /*#__PURE__*/_jsx(OwningTeamPickerModal, {
      defaultSelectedOwningTeam: commonOwningTeam ?
      // Default to the common owning team if there is one
      commonOwningTeam : hasOwningTeams ?
      // No default selection if there are multiple owning teams
      undefined :
      // If there are no owning teams, default to the "None" option
      noOwningTeamItem,
      onClose: function onClose() {
        return setShowTeamSelectorModal(false);
      },
      onSubmit: selectNewTeam,
      contentIds: contentIds,
      selectableTeamIds: selectableTeamIds
    })]
  }));
};
export default OwningTeamField;